import React from 'react';
import { ArrowRight, MapPin } from 'lucide-react';
import { BRAND_NAME, destinations } from '../data/site';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
export function Discover() {
  return <section id="taveuni" className="w-full bg-ivory py-24 sm:py-28 lg:py-36" data-id="element-24" data-mp="3dptwgzm451jk">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12" data-id="element-25" data-mp="3imsoncm7uyf4">
        <Reveal className="max-w-3xl" data-id="element-26" data-mp="a7sis9tyswlh">
          <SectionLabel data-id="element-27" data-mp="a93owgavugfr">The Island</SectionLabel>
          <h2 className="mt-6 font-serif text-[clamp(2rem,4.5vw,3.5rem)] font-light leading-[1.08] text-forest-deep" data-id="element-28" data-mp="f6vfn6zsjwid">
            Discover Taveuni
          </h2>
          <p className="mt-4 font-serif text-2xl italic text-ocean" data-id="element-29" data-mp="931ai5zde5r">
            The Garden Island of Fiji.
          </p>
          <p className="mt-6 text-[16px] leading-[1.85] text-forest-deep/65" data-id="element-30" data-mp="5asea3crk1wh">
            From lush rainforests and waterfalls to beautiful coastlines and
            world-class diving, Taveuni offers a unique combination of adventure,
            nature, and island life.
          </p>
        </Reveal>

        <Reveal delay={0.08} data-id="element-31" data-mp="1j5dxj0p8088k">
          <div className="mt-10 flex max-w-3xl items-start gap-4 rounded-[1.5rem] border border-gold/40 bg-sand-light px-7 py-6" data-id="element-32" data-mp="1e4zmraw8ik6u">
            <MapPin className="mt-0.5 h-5 w-5 flex-shrink-0 text-gold" strokeWidth={1.4} aria-hidden="true" data-id="element-33" data-mp="1s50o0rgevtmu" />
            <p className="text-[15px] leading-[1.8] text-forest-deep/75" data-id="element-34" data-mp="221vlr84v1q02">
              <span className="font-semibold text-forest-deep" data-id="element-35" data-mp="2202eprqc53rj">
                A strategic base on the island.
              </span>{' '}
              Staying at {BRAND_NAME} places you close to Taveuni's main
              attractions — waterfalls, rainforest trails, coastal walks,
              beaches and world-class dive sites are all within easy reach, so
              you spend less time travelling and more time exploring.
            </p>
          </div>
        </Reveal>

        <ul className="mt-14 grid gap-5 sm:grid-cols-2 lg:mt-20 lg:grid-cols-6" data-id="element-36" data-mp="2fvmtqc2y11to">
          {destinations.map((destination, i) => <Reveal as="li" key={destination.title} delay={i * 0.07} className={i < 2 ? 'lg:col-span-3' : 'lg:col-span-2'} data-id="element-37" data-mp="1hhppor5pu8qm" data-mpi={i}>
              <article className="group relative h-full overflow-hidden rounded-[1.75rem] bg-forest-deep" data-id="element-38" data-mp="1r7sk8vshjur2">
                <img src={destination.image} alt={destination.alt} loading="lazy" className={`w-full object-cover opacity-90 transition-all duration-[1200ms] ease-calm group-hover:scale-[1.06] group-hover:opacity-100 ${i < 2 ? 'h-[380px] lg:h-[440px]' : 'h-[340px] lg:h-[400px]'}`} data-id="element-39" data-mp="1w75cjw24lu11" />
                <div className="absolute inset-0 bg-gradient-to-t from-forest-deep/90 via-forest-deep/25 to-transparent" data-id="element-40" data-mp="auc313r46xiw" />
                <div className="absolute inset-x-0 bottom-0 p-7" data-id="element-41" data-mp="ftezhzt13vf9">
                  <h3 className="text-[12px] font-semibold uppercase tracking-[0.18em] text-ivory" data-id="element-42" data-mp="89mhjggrikou">
                    {destination.title}
                  </h3>
                  <p className="mt-2.5 max-w-sm text-[14px] leading-relaxed text-ivory/75" data-id="element-43" data-mp="3gb8d8oh9rtr">
                    {destination.description}
                  </p>
                  <span className="mt-5 inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-gold-soft" data-id="element-44" data-mp="3pqnmllnt5ims">
                    Explore
                    <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 ease-calm group-hover:translate-x-1.5" aria-hidden="true" data-id="element-45" data-mp="m8ds4swf1o88" />
                  </span>
                </div>
                <a href="#book" className="absolute inset-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" aria-label={`Explore ${destination.title}`} data-id="element-46" data-mp="d7xnhg3xsb1s" />
              </article>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}